import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';
import { RoutingVariablesService } from 'src/app/shared/services/routing-variables.service';

export interface empresa{
  cantCursos: number;
  cantInstructores: string;
  categorias: string;
  descripcion: string;
  enlaceLinkedin: string;
  fechaCreacion: Date;
  foto: string;
  fotoFondo: string;
  nombre: string;
  publicado: boolean;
  resumen: string;
  sitioWeb: string;
}

export interface cursoEmpresa{
  foto: string;
  titulo: string;
  resumen: string;
  precioFinal: number;
  id: string;
}

export interface instructorEmpresa{
  nombre: string;
  id: string;
  resumen: string;
  foto: string; 
}

@Component({
  selector: 'app-detalle-empresas',
  templateUrl: './detalle-empresas.component.html',
  styleUrls: ['./detalle-empresas.component.css']
})
export class DetalleEmpresasComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private afs: AngularFirestore,
    private shared: RoutingVariablesService,
    private router: Router,
    private seo: SeoService,
  ) { }

  id = this.route.snapshot.paramMap.get('id');
  empresa: empresa;
  cursosEmpresa: cursoEmpresa[] = [];
  instructoresEmpresa: instructorEmpresa[] = [];
  loaded: number = 0;

  async ngOnInit(): Promise<void> {
    this.cargarEmpresa();
  }

  cargarEmpresa() {
    this.afs.collection('empresas').doc(this.id).ref.get().then(snap => {
      const empresa = snap.data();
      this.empresa = {
        cantCursos: empresa['cantCursos'],
        cantInstructores: empresa['cantInstructores'], 
        categorias: empresa['categorias'],
        descripcion: empresa['descripcion'], 
        enlaceLinkedin: empresa['enlaceLinkedin'], 
        fechaCreacion: empresa['fechaCreacion'],
        foto: empresa['foto'],
        fotoFondo: empresa['fotoFondo'], 
        nombre: empresa['nombre'],
        publicado: empresa['publicado'], 
        resumen: empresa['resumen'],
        sitioWeb: empresa['sitioWeb'], 
      }
    }).then(() => {
      this.seo.generateTags({
        title: this.empresa.nombre,
        image: this.empresa.foto,
        description: this.empresa.descripcion
      })
      this.afs.collection('instructores').ref.where('empresaId', '==', this.id).get().then(response => {
        response.docs.forEach(doc => {
          const data = doc.data();
          const instructor: instructorEmpresa = {
            nombre: data['nombre'], 
            resumen: data['resumen'],
            foto: data['foto'],
            id: doc.id,
          }
          if (doc.data()['publicado']){
            this.instructoresEmpresa = this.instructoresEmpresa.concat(instructor);
          }
        });
      }).then(() => {
        this.afs.collection('cursos').ref.where('empresaId', '==', this.id).get().then(response => {
          response.docs.forEach(doc => {
            const data = doc.data();
            const curso: cursoEmpresa = {
              foto: data['foto'], 
              titulo: data['titulo'],
              resumen: data['resumen'],
              precioFinal: data['precioFinal'],
              id: doc.id,
            }
            if (doc.data()['publicado']){
              this.cursosEmpresa = this.cursosEmpresa.concat(curso);
            }
            this.loaded = 1;
          });
        }).catch(error => {
          console.log(error);
        })
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  }

  regresarEmpresas() {
    const obj = { tipoBusqueda: "empresas"};
    this.shared.pushData(obj);
    this.router.navigate(['/buscar']);
  }
}
